exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content[data-v-74a28851]{padding:20px}.form-field[data-v-74a28851]{margin:20px auto}textarea[data-v-74a28851]{width:100%}input.invalid[data-v-74a28851]{color:darkred}input.valid[data-v-74a28851]{color:#006400}.form-field>label[data-v-74a28851]{display:block;margin-bottom:4px}.content .button-bar[data-v-74a28851]{margin-top:30px}.button-bar button[data-v-74a28851]{margin-right:20px}.radio-option[data-v-74a28851]{display:block;margin:8px 0}.error-msg[data-v-74a28851]{text-align:center;font-size:smaller}.error-msg b[data-v-74a28851]{color:darkred}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-74a28851","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/IncidentEdit.vue
// module id = 165
// module chunks = 0